import React, { ReactElement } from 'react'
import CaptionFont from '../../../../Theme/Fonts/Caption'
import { TextAlignTypes } from '../../../../Theme/Fonts/FontTypes'

type Props = {
    children: string
    align?: TextAlignTypes
}

const HeaderFont = ({ children, align }: Props): ReactElement => {
    return (
        <CaptionFont textAlign={align} color="keshi-3" numberOfLines={1}>
            {children}
        </CaptionFont>
    )
}

export default HeaderFont
